module.exports = __webpack_public_path__ + "img/pic5.304b01d5.png";